export default {"src":"/_next/static/media/home.e490a49f.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};